export function isIsbn13(value: string) {
  const cleanedValue = value?.split("-").join("") ?? "";
  const matchesPattern = /^(978|979)\d{10}$/.exec(cleanedValue);

  if (matchesPattern) {
    const expectedCheckDigit = parseInt(
      cleanedValue.charAt(cleanedValue.length - 1),
      10
    );

    let sum = 0;
    for (let i = 0; i < 12; i++) {
      const digit = parseInt(cleanedValue[i], 10);
      sum += i % 2 === 0 ? digit : digit * 3;
    }
    const actualCheckDigit = (10 - (sum % 10)) % 10;
    return actualCheckDigit === expectedCheckDigit;
  }
  return false;
}
